// [@vidstack/eliza] THIS FILE IS AUTO GENERATED - SEE `eliza.config.ts`

import "../../define/vds-toggle-button.js";
import * as React from "react";
import { createComponent } from "../lib/index.js";
import { ToggleButtonElement } from "../../ui/toggle-button/index.js";

const EVENTS = {} as const;

/** The foundation for any toggle button such as a `play-button` or `mute-button`. */
const ToggleButton = createComponent(
  React,
  "vds-toggle-button",
  ToggleButtonElement,
  EVENTS,
  "ToggleButton"
);

export default ToggleButton;
